'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FloatingCTAProps {
  className?: string;
  isEnglish?: boolean;
}

const FloatingCTA = ({ className = '', isEnglish = false }: FloatingCTAProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById('acasa');
      if (heroSection) {
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
        const scrollPosition = window.pageYOffset + window.innerHeight;
        setIsVisible(scrollPosition > heroBottom);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const headerOffset = 80;
      const elementPosition = contactSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <button data-component-id="src/components/common/FloatingCTA.tsx:45:4" data-component-path="src/components/common/FloatingCTA.tsx" data-component-line="45" data-component-end-line="54" data-component-file="FloatingCTA.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
      onClick={handleClick}
      className={`fixed bottom-6 right-6 z-[900] px-6 py-4 bg-primary text-primary-foreground font-body font-semibold text-sm rounded-full shadow-cta hover:bg-primary/90 transition-all duration-base flex items-center gap-2 ${
      isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'} ${
      className}`}
      aria-label={isEnglish ? 'Contact' : 'Contactează-ne'}>

      <Icon data-component-id="src/components/common/FloatingCTA.tsx:52:6" data-component-path="src/components/common/FloatingCTA.tsx" data-component-line="52" data-component-end-line="52" data-component-file="FloatingCTA.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22PhoneIcon%22%7D" name="PhoneIcon" size={20} />
      <span data-component-id="src/components/common/FloatingCTA.tsx:53:6" data-component-path="src/components/common/FloatingCTA.tsx" data-component-line="53" data-component-end-line="53" data-component-file="FloatingCTA.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{isEnglish ? 'Contact us now' : 'Contactează-ne acum'}</span>
    </button>);

};

export default FloatingCTA;